import React from 'react';
import { cn } from '@chapche/ui';

const RadioLabel = ({ value, title, changeValue, type }) => (
    <div
        className={cn(
            'block__content radio__container flex w-max cursor-pointer items-end gap-12',
            value === true && 'radio__container_active',
        )}
        onClick={() => changeValue(!value, type)}
    >
        <span
            className={cn(
                'radio__round box-border h-24 w-24 rounded-full border-solid border-green-accent bg-white transition-[border-width] duration-200',
                value === true ? 'radio__round_active border-[7px]' : 'border-2',
            )}
        />
        <span className="radio__content first-letter:uppercase">{title}</span>
    </div>
);

export default RadioLabel;
